/**
 * Settings → Operations → "Files redesign pilot".
 * TEMPORARY — delete with the gate. See REMOVAL CHECKLIST in utils/filesRedesignAccess.ts.
 */
import React from 'react';
import { useAuth } from '../../utils/AuthContext';
import { filesRedesignFlag } from '../../utils/filesRedesignAccess';
import { resetProjectFilesTourSeen } from '../../utils/projectFilesTourSteps';
import PilotFlagCard from './PilotFlagCard';
import './FilesRedesignPilotCard.css';

const FilesRedesignPilotCard: React.FC = () => {
  const { user } = useAuth();
  const resetTourButton = (
    <button
      type="button"
      className="frp-btn frp-btn--ghost"
      onClick={() => {
        resetProjectFilesTourSeen(user?.id);
        window.alert('The Files walkthrough will show again the next time you open a project’s Files tab.');
      }}
    >
      Reset Files walkthrough
    </button>
  );

  return (
    <PilotFlagCard
      flag={filesRedesignFlag}
      title="Files redesign pilot"
      ariaLabel="Files redesign pilot"
      description="The redesigned Project Hub Files tab (Deliverables / Submittals / RFQs / Project folders, structures, split tracks, Client view) is only shown to the people below. Everyone else keeps the classic single-page layout until you enable it for everyone."
      enableAllConfirm='Enable the redesigned Files tab for everyone? Every staff account switches to the new layout on next load (the "Classic files view" checkbox stays as an escape hatch).'
      gaNotice={
        <>
          The pilot gate is now dead code — remove it in the next release (REMOVAL CHECKLIST in <code>utils/filesRedesignAccess.ts</code>).
        </>
      }
      extraActions={resetTourButton}
    />
  );
};

export default FilesRedesignPilotCard;
